export default "__VITE_ASSET__BLWObp23__"